import React, { Component, Fragment, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Container } from 'reactstrap';
import { Col, Button, Row } from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";
import Modal from '@material-ui/core/Modal';

class DigitalSignature extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    };

    componentDidMount = () => {
    }

    cleanCanvas = () => {
        this.sigCanvas.clear();
    }

    confirmSignature = () => {
        let dataBase64 = this.sigCanvas.getTrimmedCanvas().toDataURL('image/png');
        this.props.confirmSign(dataBase64);
        this.props.closeModalSignature();
    }

    render() {

        console.log(this.sigCanvas);

        return (
            <Fragment>
                <Modal
                    open={this.props.openModalSignature}
                    onClose={e => {
                        this.props.closeModalSignature();
                    }}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                    disableEnforceFocus={true}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <Row>
                            <Col md={12}>
                                <div style={{ border: '1px groove black' }}>
                                    <SignatureCanvas
                                        ref={(ref) => { this.sigCanvas = ref }}
                                        penColor='black'
                                        canvasProps={{ width: 1000, height: 300, className: 'sigCanvas' }}
                                    />

                                </div>
                            </Col>
                        </Row>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                style={{ marginTop: 10, marginRight: 10 }}
                                className="btn-sm"
                                variant="contained"
                                color="danger"
                                onClick={() => this.cleanCanvas()}>
                                Limpiar
                            </Button>
                            <Button
                                style={{ marginTop: 10, marginRight: 10 }}
                                className="btn-sm"
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.confirmSignature();
                                }}
                            >
                                Confirmar Firma
                            </Button>

                            <Button
                                style={{ marginTop: 10, marginRight: 10 }}
                                className="btn-sm"
                                variant="contained"
                                onClick={() => {
                                    this.props.closeModalSignature();
                                }}
                            >
                                Cerrar
                            </Button>
                        </div>
                    </div>
                </Modal>
            </Fragment>
        );
    }
};
export default DigitalSignature;
